import { jsx } from "react/jsx-runtime";
import { RequiredIndicatorPlacement, RequiredIndicator } from "@wix/ambassador-forms-v4-form/types";
import { Checkbox } from "@wix/wix-ui-tpa/cssVars";
import classNames from "classnames";
import { useRef, useCallback } from "react";
import { useFocusFieldEvent } from "../../contexts/events-context.js";
import { useForcedState, ForcedState } from "../../contexts/forced-state-context.js";
import { FieldRichLabelWUT } from "../field-rich-label/field-rich-label-wut.js";
import { Widget } from "../widget/widget.js";
import styles from "./checkbox-field-wut.module.scss";
import { classes } from "./checkbox-field-wut.st.css";
const CheckboxFieldWUT = ({
  id,
  label,
  disabled = false,
  value = false,
  onChange,
  onFocus,
  onBlur,
  hasError = false,
  errorMessage,
  required,
  FieldLayout,
  requiredIndicatorType = RequiredIndicator.ASTERISK,
  requiredIndicatorPlacement = RequiredIndicatorPlacement.AFTER_FIELD_TITLE,
  widgetHtml,
  widgetEnabled
}) => {
  const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
  const checkboxRef = useRef(null);
  const handleChange = useCallback(
    (event) => {
      onChange?.(event.checked);
    },
    [onChange]
  );
  useFocusFieldEvent(() => {
    checkboxRef.current?.focus({ preventScroll: true });
  }, id);
  return /* @__PURE__ */ jsx(
    FieldLayout,
    {
      fieldId: id,
      renderLabel: () => null,
      renderInput: () => widgetHtml && widgetEnabled ? /* @__PURE__ */ jsx(
        Widget,
        {
          fieldId: id,
          widgetHtml,
          onChange,
          value
        }
      ) : /* @__PURE__ */ jsx("div", { onBlur, onFocus, children: /* @__PURE__ */ jsx(
        Checkbox,
        {
          newErrorMessage: true,
          className: classNames(
            styles.checkbox,
            classes.root,
            classes.checkbox,
            {
              [classes.error]: hasError,
              [classes.hover]: forcedHover
            }
          ),
          label: /* @__PURE__ */ jsx(
            FieldRichLabelWUT,
            {
              label,
              disabled,
              required,
              requiredIndicatorType,
              requiredIndicatorPlacement
            }
          ),
          checked: Boolean(value),
          onChange: handleChange,
          disabled,
          error: hasError,
          errorMessage,
          required,
          showAsterisk: false,
          ref: checkboxRef
        }
      ) }),
      renderDescription: () => null
    }
  );
};
export {
  CheckboxFieldWUT
};
//# sourceMappingURL=checkbox-field-wut.js.map
